/* eslint-disable react/no-danger */
import React, {useState, useEffect }from 'react';
import PropTypes from 'prop-types';
import styles from './BYOButton.scss';

const BYOButton = (props) => {
  const { website } = props;
  const [
    canShowBYOButton,
    setCanShowBYOButton,
  ] = useState(false);

  const [
    canShowKiaButton,
    setCanShowKiaButton,
  ] = useState(false);

  useEffect(() => {
    setCanShowBYOButton(website?.Dealer?.dealerType === 'BYOEnabled' || website?.Dealer?.dealerType === 'BYOOnly');
    setCanShowKiaButton(website?.Dealer?.featureConfig?.kiaReservation?.enabled);
  }, [website]);

  return (
    <div className={styles.BYOButtonsContainer}>
      {canShowBYOButton && (
        <div className={styles.BYOButtonContainer}>
          <div className='prodigy-standalone-byo-button'>
            {/* This button markup to be provided by DDC initially */}
            <button class="prodigy-button" data-action="byo">BYO</button>
          </div>
        </div>
      )}
      {canShowKiaButton && (
        <>
          <div className={styles.KiaButtonContainer}>
            <div className='prodigy-kia-reservation-banner'></div>
          </div>
          <div className={styles.KiaButtonContainer}>
          <div className='prodigy-kia-reservation-button'></div>
        </div>        
        </>
      )}
    </div>
  );
};

BYOButton.propTypes = {
  website: PropTypes.object,
};

export default BYOButton;



// WEBPACK FOOTER //
// ./src/components/BYOButton/BYOButton.js